<bn-web-ui-content
  class="demo-components"
  heading="Demo Components Page">
  <div class="row mb-4">
    <div
      class="col-12 mb-4"
      [formGroup]="miniInputForm">
      <bn-web-ui-input
        formControlName="data"
        label="Input with label"
        placeholder="Placeholder">
        <div
          data-actionable-item
          (click)="actionableItemClick()">
          Buuu baaa
        </div>
        <button
          data-actionable-item
          (click)="actionableItemClick()">
          Buuu baaa
        </button>
      </bn-web-ui-input>
    </div>
    <div class="col-12 mb-4">
      <bn-web-ui-card heading="New badges 2025 (grouped by color)">
        <div class="badge-demo-scrollable">
          @for (style of ['pill', 'tag']; track style) {
            @for (appearance of ['solid', 'outline']; track appearance) {
              <h5 class="mt-5 mb-3 pt-3 border-top text-dark">
                appearance: <span class="text-danger">{{ appearance }}</span> <br />
                style: <span class="text-danger">{{ style }}</span>
              </h5>
              <div class="bn-table bn-table--condensed mb-4">
                <table class="table table-sm table-hover align-middle">
                  <thead class="table-light">
                    <tr>
                      <th class="text-start"></th>
                      @for (color of badgeColors; track color) {
                        <th>
                          {{ color }}
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (size of ['md', 'sm', 'xs']; track size; let i = $index) {
                      <tr
                        class="border-top"
                        [class.table-striped-row]="i % 2 === 1">
                        <td>
                          <pre>{{ size }} </pre>
                        </td>
                        @for (color of badgeColors; track color) {
                          <td>
                            <span class="bn-badge-2 bn-badge-2--{{ size }} bn-badge-2--{{ appearance }} bn-badge-2--{{ style }} bn-badge-2--{{ color }}">
                              {{ appearance }} {{ style }} {{ color }}
                            </span>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }
        </div>
      </bn-web-ui-card>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-3">
      <bn-web-ui-trial-balance
        expirationDate="2024-12-29T10:00:00"
        [balance]="20" />
    </div>
  </div>
  <div class="row">
    <div class="col-12 mb-4">
      <bn-web-ui-steps-component (selectedIndexChangedEvent)="onStepClick($event)">
        <bn-web-ui-card heading="Steps content">
          <div>Selected step index: {{ selectedStepsIndex }}</div>
        </bn-web-ui-card>
      </bn-web-ui-steps-component>
    </div>
    <div class="mt-2 mb-2">
      <bn-web-ui-card [formGroup]="inputOverrideForm">
        <bn-web-ui-input
          class="flex-grow-1"
          formControlName="overrideInput"
          inputName="Default/Override input"
          placeholder='e.g. /bin/sh -c echo "Hello Bunny!" && sleep 3600'
          size="md"
          [withOverride]="true" />
      </bn-web-ui-card>
    </div>
    <div class="mt-2 mb-2">
      <bn-web-ui-card
        heading="Toggle addons (input + select)"
        [formGroup]="toggleAddonsForm">
        <div class="row">
          <div class="col-12 col-xl-6">
            <bn-web-ui-input
              formControlName="regexValue"
              label="Variable value"
              placeholder="Enter value"
              size="md"
              [options]="regexToggleOptions"
              (clickAction)="onRegexToggle($event)" />
          </div>
          <div class="col-12 col-xl-6">
            <bn-web-ui-select
              formControlName="operator"
              label="Operator"
              size="md"
              [items]="toggleOperatorItems"
              [options]="negateToggleOptions"
              (clickAction)="onNegateToggle($event)" />
          </div>
        </div>
        <p class="mt-2">isRegex: {{ isRegex }} · isNegated: {{ isNegated }}</p>
      </bn-web-ui-card>
    </div>
    <div class="mb-5">
      <bn-web-ui-step-card
        description="Short desc for this settings"
        heading="Choose package fixed price"
        [number]="1">
        <div class="row gap-2">
          <div class="col">
            <bn-web-ui-pricing-card [item]="fixedPriceItem" />
          </div>
        </div>
      </bn-web-ui-step-card>
    </div>
    <div class="mb-2">Selected list item: {{ listPackagesForm.get('cardItem')?.value }}</div>
    <div class="mb-5">
      <bn-web-ui-step-card
        description="Short desc for this settings"
        heading="Choose package lists"
        [formGroup]="listPackagesForm"
        [number]="2">
        <div class="row gap-2 g-0">
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem1"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem1.id" />
          </div>
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem2"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem2.id" />
          </div>
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem3"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem3.id" />
          </div>
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem4"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem4.id" />
          </div>
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem5"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem5.id" />
          </div>
          <div class="col">
            <bn-web-ui-pricing-card
              formControlName="cardItem"
              [item]="listPriceItem6"
              [selected]="listPackagesForm.get('cardItem')?.value === listPriceItem6.id" />
          </div>
        </div>
      </bn-web-ui-step-card>
    </div>
    <div class="col-12 mb-4">
      <bn-web-ui-step-card
        heading="Advanced settings"
        [formGroup]="advancedSettingsForm"
        [number]="5">
        <bn-web-ui-advanced-settings formControlName="advancedSettings" />
      </bn-web-ui-step-card>
    </div>
    <div class="col-12 mb-4">
      <bn-web-ui-card heading="Container 1">
        <bn-web-ui-entity-overview [items]="containerOverviewItems" />
        <h3 class="my-3">Endpoints</h3>
        <bn-web-ui-entity-overview [items]="[containerOverviewItems[0]]" />
        <div
          class="right-addons flex-grow-1 text-end"
          heading-after>
          <bn-web-ui-button
            class="me-1"
            itemStyle="stroke"
            size="sm"
            >Edit
          </bn-web-ui-button>
          <bn-web-ui-button
            itemStyle="stroke"
            size="sm"
            >Delete
          </bn-web-ui-button>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-6 mb-4">
      <bn-web-ui-card heading="Container 2">
        <bn-web-ui-entity-overview [items]="containerOverviewItems" />
        <div
          class="right-addons flex-grow-1 text-end"
          heading-after>
          <bn-web-ui-button
            class="me-1"
            itemStyle="stroke"
            size="sm"
            >Edit
          </bn-web-ui-button>
          <bn-web-ui-button
            itemStyle="stroke"
            size="sm"
            >Delete
          </bn-web-ui-button>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-6 mb-4">
      <bn-web-ui-card heading="Container 3">
        <bn-web-ui-entity-overview [items]="containerOverviewItems" />
      </bn-web-ui-card>
    </div>

    <div class="col-12 col-lg-3 mb-4">
      <bn-web-ui-stat-card
        label="Stat card title"
        [showChange]="false"
        [value]="55" />
    </div>
    <div class="col-12 col-lg-3 mb-4">
      <bn-web-ui-card [formGroup]="inputMaskForm">
        <bn-web-ui-input
          formControlName="timeInput"
          label="Masked input: "
          placeholder="00:00:00"
          [inputMask]="inputMask" />
        <pre class="demo-components__output-data">{{ inputMaskForm.value | json }}</pre>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-3 mb-4">
      <bn-web-ui-card [formGroup]="numberForm">
        <bn-web-ui-input
          align="center"
          formControlName="numberInput"
          label="Numeric input: "
          placeholder="2"
          type="number"
          [max]="5"
          [min]="2"
          [options]="{ withCounterButtons: true }" />
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card heading="Skeletons">
        <ngx-skeleton-loader />
        <ngx-skeleton-loader />
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-short-list
        heading="Latest"
        name="Pull Zones"
        type="table"
        [rightButton]="[{ name: 'Show all', itemStyle: 'stroke' }]"
        [tableItems]="shortListTableItems"
        (headerButtonClicked)="onShortListHeaderButtonClicked()"
        (tableLinkClicked)="onShortListLinkClicked($event)" />
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-short-list
        heading="Selected for you"
        name="Guides"
        type="posts"
        [postItems]="shortListPostItems"
        [rightButton]="[{ name: 'Show all', itemStyle: 'stroke' }]"
        [tableItems]="shortListTableItems"
        (headerButtonClicked)="onShortListHeaderButtonClicked()"
        (tableLinkClicked)="onShortListLinkClicked($event)" />
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Datepickers"
        [isFullHeight]="true">
        <div class="row">
          <div class="col-6">
            <bn-web-ui-datepicker
              placeholder="Select date"
              type="range"
              [(ngModel)]="dateRangePickerValue" />
          </div>
          <div class="col-6">
            <bn-web-ui-datepicker
              placeholder="Select date"
              [datesDisabled]="datePickerDatesDisabled"
              [maxDate]="datePickerMaxDate"
              [minDate]="datePickerMinDate"
              [(ngModel)]="datePickerValue" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <bn-web-ui-datepicker
              placeholder="Select date"
              type="range"
              [ranges]="undefined"
              [(ngModel)]="dateRangePickerValue" />
          </div>
          <div class="col-6">
            <bn-web-ui-datepicker
              placeholder="Select date"
              type="range"
              [ranges]="[1, 2, 3, 4, 5]"
              [(ngModel)]="dateRangePickerValue" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <bn-web-ui-datepicker
              innerLabel="Moj najljubsi datum:"
              itemStyle="secondary"
              placeholder="Select date"
              size="xxs"
              type="range"
              [(ngModel)]="dateRangePickerValue" />
          </div>
          <div class="col-6">
            <bn-web-ui-datepicker
              itemStyle="secondary"
              placeholder="Select date"
              size="xs"
              type="range"
              [(ngModel)]="dateRangePickerValue" />
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Simple tabs"
        [isFullHeight]="true">
        <bn-web-ui-tabs
          class="my-4"
          [activeTab]="activeTab"
          [tabItems]="tabItems"
          (activeTabChange)="onActiveTabChange($event)" />
        <pre class="demo-components__output-data">Active tab: {{ activeTab }}</pre>
      </bn-web-ui-card>
    </div>
    <div class="col col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Simple tabs 'secondary' style"
        [isFullHeight]="true">
        <bn-web-ui-tabs
          class="my-4"
          [activeTab]="activeTab"
          [itemStyle]="'secondary'"
          [tabItems]="tabItems"
          (activeTabChange)="onActiveTabChange($event)" />
        <pre class="demo-components__output-data">Active tab: {{ activeTab }}</pre>
      </bn-web-ui-card>
    </div>
    <div class="col col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Form tabs"
        [formGroup]="form"
        [isFullHeight]="true">
        <bn-web-ui-radio-tabs
          formControlName="test"
          [items]="radioTabItems" />
        <pre
          class="demo-components__output-data"
          title="Form value"></pre>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Switch"
        [isFullHeight]="true">
        <div class="row">
          <div class="col-12 mb-4">
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch xs"
                size="xs"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch small"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch medium"
                size="md"
                [ngModel]="false" />
            </div>
            <div>
              <bn-web-ui-switch
                class="mb-3"
                label="Switch large "
                size="lg"
                [ngModel]="false" />
            </div>
          </div>
          <div class="col-xl-6">
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch xs"
                size="xs"
                [disabled]="true"
                [ngModel]="false" />
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch small"
                [disabled]="true"
                [ngModel]="false" />
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch medium"
                size="md"
                [disabled]="true"
                [ngModel]="false" />
            </div>
            <div>
              <bn-web-ui-switch
                class="mb-3"
                label="Switch large "
                size="lg"
                [disabled]="true"
                [ngModel]="false" />
            </div>
          </div>
          <div class="col-xl-6">
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch xs"
                size="xs"
                [disabled]="true"
                [ngModel]="true" />
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch small"
                [disabled]="true"
                [ngModel]="true" />
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                label="Switch medium"
                size="md"
                [disabled]="true"
                [ngModel]="true" />
            </div>
            <div>
              <bn-web-ui-switch
                class="mb-3"
                label="Switch large "
                size="lg"
                [disabled]="true"
                [ngModel]="true" />
            </div>
          </div>
          <div class="col-xl-6">
            <div class="mb-3">
              <bn-web-ui-switch
                contextType="dark"
                label="Switch xs"
                size="xs"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                contextType="dark"
                label="Switch small"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                contextType="dark"
                label="Switch medium"
                size="md"
                [ngModel]="false" />
            </div>
            <div>
              <bn-web-ui-switch
                class="mb-3"
                contextType="dark"
                label="Switch large "
                size="lg"
                [ngModel]="false" />
              <bn-web-ui-switch
                class="mb-3"
                contextType="dark"
                label="Switch large "
                size="lg"
                [disabled]="true"
                [ngModel]="false"
                >Disabled true
              </bn-web-ui-switch>
              <bn-web-ui-switch
                class="mb-3"
                contextType="dark"
                label="Switch large "
                size="lg"
                [disabled]="true"
                [ngModel]="true"
                >Disabled true= / Checked
              </bn-web-ui-switch>
            </div>
          </div>
          <div class="col-xl-6">
            <label>PREMIUM</label>
            <div class="mb-3">
              <bn-web-ui-switch
                checkedContextType="premium"
                label="Switch xs"
                size="xs"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                checkedContextType="premium"
                label="Switch small"
                [ngModel]="false"
                >Description of what this switch does...
              </bn-web-ui-switch>
            </div>
            <div class="mb-3">
              <bn-web-ui-switch
                checkedContextType="premium"
                label="Switch medium"
                size="md"
                [ngModel]="false" />
            </div>
            <div>
              <bn-web-ui-switch
                checkedContextType="premium"
                class="mb-3"
                label="Switch large "
                size="lg"
                [ngModel]="false" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-4">
              <div class="mb-3">
                <bn-web-ui-switch
                  itemStyle="secondary"
                  label="Switch small"
                  size="xs"
                  [ngModel]="false"
                  >Description of what this switch does...
                </bn-web-ui-switch>
              </div>
              <div class="mb-3">
                <bn-web-ui-switch
                  itemStyle="secondary"
                  label="Switch small"
                  [ngModel]="false"
                  >Description of what this switch does...
                </bn-web-ui-switch>
              </div>
              <div class="mb-3">
                <bn-web-ui-switch
                  itemStyle="secondary"
                  label="Switch medium"
                  size="md"
                  [ngModel]="false" />
              </div>
              <div>
                <bn-web-ui-switch
                  class="mb-3"
                  itemStyle="secondary"
                  label="Switch large "
                  size="lg"
                  [ngModel]="false" />
              </div>
            </div>
            <div class="col-xl-6">
              <div class="mb-3">
                <bn-web-ui-switch
                  itemStyle="secondary"
                  label="Switch small"
                  [disabled]="true"
                  [ngModel]="true" />
              </div>
              <div class="mb-3">
                <bn-web-ui-switch
                  itemStyle="secondary"
                  label="Switch medium"
                  size="md"
                  [disabled]="true"
                  [ngModel]="true" />
              </div>
              <div>
                <bn-web-ui-switch
                  class="mb-3"
                  itemStyle="secondary"
                  label="Switch large "
                  size="lg"
                  [disabled]="true"
                  [ngModel]="true" />
              </div>
            </div>
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        class="col-12"
        heading="Dropdown"
        [isFullHeight]="true">
        <bn-web-ui-dropdown-menu
          class="me-4 mb-4"
          [items]="dropdownItems"
          [options]="{ align: 'start', size: 'sm', closeOnItemClick: true, position: 'left' }">
          <span trigger>
            <button
              bn-web-ui-button
              itemStyle="secondary">
              Dropdown menu
            </button>
          </span>
        </bn-web-ui-dropdown-menu>
        <bn-web-ui-dropdown-menu
          class="me-4 mb-4"
          [items]="dropdownItems"
          [options]="{ align: 'start', size: 'sm', closeOnItemClick: true, position: 'right' }">
          <span trigger>
            <button
              bn-web-ui-button
              itemStyle="secondary">
              Dropdown menu
            </button>
          </span>
        </bn-web-ui-dropdown-menu>
        <bn-web-ui-dropdown-menu
          class="me-4 mb-4"
          [items]="dropdownItems"
          [options]="{ align: 'start', size: 'sm', closeOnItemClick: true, position: 'top' }">
          <span trigger>
            <button
              bn-web-ui-button
              itemStyle="secondary">
              Dropdown menu
            </button>
          </span>
        </bn-web-ui-dropdown-menu>
        <bn-web-ui-dropdown-menu
          class="me-4 mb-4"
          [items]="dropdownItems"
          [options]="{ align: 'start', size: 'sm', closeOnItemClick: true, position: 'bottom' }">
          <span trigger>
            <button
              bn-web-ui-button
              itemStyle="secondary">
              Dropdown menu
            </button>
          </span>
        </bn-web-ui-dropdown-menu>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        class="mb-6"
        heading="Buttons"
        [isFullHeight]="true">
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="primary"
          size="sm"
          >Primary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="primary"
          size="md"
          >Primary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="primary"
          size="lg"
          >Primary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="primary"
          size="xl"
          >Primary</a
        >
        <br /><br />
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="secondary"
          size="sm"
          >Secondary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="secondary"
          size="md"
          >Secondary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="secondary"
          size="lg"
          >Secondary</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="secondary"
          size="xl"
          >Secondary</a
        >
        <br /><br />
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="danger"
          size="sm"
          >Alert</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="danger"
          size="md"
          >Alert</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="danger"
          size="lg"
          >Alert</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="danger"
          size="xl"
          >Alert</a
        >
        <br /><br />
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="stroke"
          size="sm"
          >Stroke</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="stroke"
          size="md"
          >Stroke</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="stroke"
          size="lg"
          >Stroke</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="stroke"
          size="xl"
          >Stroke</a
        >

        <br /><br />
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="link"
          size="sm"
          [disabled]="true"
          >Link</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="link"
          size="md"
          >Link</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="link"
          size="lg"
          >Link</a
        >
        <a
          bn-web-ui-button
          class="bn-level__item"
          itemStyle="link"
          size="xl"
          >Link</a
        >

        <bn-web-ui-button-dropdown
          class="bn-level__item"
          itemStyle="link"
          size="lg"
          >Dropdown
        </bn-web-ui-button-dropdown>

        <bn-web-ui-button-dropdown
          class="bn-level__item"
          itemStyle="primary"
          size="md"
          >Dropdown
        </bn-web-ui-button-dropdown>

        <bn-web-ui-button-dropdown
          class="bn-level__item"
          itemStyle="secondary"
          size="sm"
          >Dropdown
        </bn-web-ui-button-dropdown>

        <bn-web-ui-button-dropdown
          class="bn-level__item"
          itemStyle="danger"
          size="xl"
          >Dropdown
        </bn-web-ui-button-dropdown>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Inputs"
        [isFullHeight]="true">
        <div class="mb-3">
          <bn-web-ui-input
            [options]="inputWithSubmitOptions"
            [(ngModel)]="inputWithSubmitModel"
            (clickAction)="inputWithSubmitClick()" />
        </div>
        <div class="mb-3">
          <bn-web-ui-button (click)="onInputButtonStyleChange()">Change Button Style</bn-web-ui-button>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card heading="Input list - bn-web-ui-select-input-list">
        <bn-web-ui-select-input-list
          size="md"
          subformReferenceId="list"
          [addButtonProps]="{
            type: 'button',
            text: 'Add item',
          }"
          [autoFocus]="false"
          [autoFocus]="false"
          [formGroup]="selectInputFormList"
          [inputProps]="{
            placeholder: 'Enter value',
          }"
          [inputProps]="{
            placeholder: 'Enter value',
          }"
          [selectProps]="{
            items: [
              { Id: 0, Name: 'Width' },
              { Id: 1, Name: 'Height' },
            ],
            options: {
              placeholder: 'Select property',
            },
          }"
          [trimSpaces]="true"
          [(ngModel)]="inputsList" />
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Leaflet Map"
        [isFullHeight]="true">
        <div class="mb-3">
          <bn-web-ui-leaflet-map [(geoCoords)]="geoCoords" />
        </div>
        <div class="row">
          <div class="col-6 mb-3">
            <bn-web-ui-input
              label="Latitude"
              type="number"
              [(ngModel)]="geoCoords[0]" />
          </div>
          <div class="col-6 mb-3">
            <bn-web-ui-input
              label="Longitude"
              type="number"
              [(ngModel)]="geoCoords[1]" />
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <form [formGroup]="formGroupWidgetForm1">
        <bn-web-ui-card
          heading="Form Group Widget - top Add"
          [isFullHeight]="true">
          <bn-dashboard-environment-variables
            formControlName="groupWidgetForm1"
            label="Environment variables"
            [formConfig]="formGroupWidgetConfig1"
            >Environment variables allow you to configure a list of variables that will be configurable when the script is deployed. This allows you to pass
            dynamic data for different use-cases.
          </bn-dashboard-environment-variables>
          <pre>{{ formWidgetText1 }}</pre>
        </bn-web-ui-card>
      </form>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <form [formGroup]="formGroupWidgetForm2">
        <bn-web-ui-card
          heading="Form Group Widget - bottom inline Add"
          [isFullHeight]="true">
          <bn-dashboard-environment-variables
            formControlName="groupWidgetForm2"
            label="Environment variables"
            [formConfig]="formGroupWidgetConfig2"
            >Environment variables allow you to configure a list of variables that will be configurable when the script is deployed. This allows you to pass
            dynamic data for different use-cases.
          </bn-dashboard-environment-variables>
          <pre>{{ formWidgetText2 }}</pre>
        </bn-web-ui-card>
      </form>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card
        heading="Notification Items aka user feed (news + notifications)"
        [isFullHeight]="true">
        <div class="row mb-3">
          <bn-web-ui-notification-item [notification]="notification" />
        </div>
        <div class="row mb-3">
          <bn-web-ui-notification-item [notification]="notification2" />
        </div>
        <div class="row mb-3">
          <bn-web-ui-notification-item [notification]="notification3" />
        </div>
      </bn-web-ui-card>
    </div>
  </div>
  <div
    class="row"
    [formGroup]="inputsForm">
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card>
        <bn-web-ui-input
          class="mt-2"
          formControlName="inputXS"
          label="Input xs"
          placeholder="Input xs"
          size="xs" />
        <bn-web-ui-input
          class="mt-2"
          formControlName="inputSM"
          label="Input sm"
          placeholder="Input sm"
          size="sm" />
        <bn-web-ui-input
          class="mt-2"
          formControlName="inputMD"
          label="Input md"
          placeholder="Input md"
          size="md" />
        <bn-web-ui-input
          class="mt-2"
          formControlName="inputLG"
          label="Input LG"
          placeholder="Input LG"
          size="lg" />
      </bn-web-ui-card>
    </div>
    <div class="col-12 col-lg-6 mb-4">
      <bn-web-ui-card>
        <div class="row">
          <div class="col-12 col-lg-6 mb-4">
            <h2>Select</h2>
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectXS"
              id="select-xs-dropdown"
              label="Select xs"
              size="xs"
              [options]="{
                width: '50%',
                dropdownWidth: 'sm',
              }" />
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectSM"
              id="select-sm-dropdown"
              label="Select sm"
              size="sm"
              [options]="{
                width: '50%',
              }" />
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectMD"
              id="select-sm-dropdown"
              label="Select md"
              size="md"
              [options]="{
                width: '50%',
                dropdownWidth: 'lg',
              }" />
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectLG"
              id="select-lg-dropdown"
              label="Select LG"
              size="lg"
              [options]="{
                width: '50%',
                dropdownWidth: 'xl',
              }" />
          </div>
          <div class="col-12 col-lg-6 mb-4">
            <h2>Select "secondary"</h2>
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectXXS"
              id="select-secondary-xxs-dropdown"
              itemStyle="secondary"
              label="Select xxs"
              size="xxs"
              [items]="[
                {
                  Id: 0,
                  Name: 'SI',
                },
                {
                  Id: 1,
                  Name: 'DE',
                },
                {
                  Id: 2,
                  Name: 'NL',
                },
                {
                  Id: 3,
                  Name: 'BE',
                },
                {
                  Id: 4,
                  Name: 'HU',
                },
                {
                  Id: 5,
                  Name: 'CZ',
                },
                {
                  Id: 6,
                  Name: 'SW',
                },
                {
                  Id: 7,
                  Name: 'FR',
                },
              ]"
              [multiple]="true"
              [options]="{
                leftIcon: 'filter',
                innerLabel: inputsForm.controls.selectXS.value ? 'Regiooooooooons:' : 'Regiooooooooons',
                showOnlyCount: true,
              }" />
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectXS"
              id="select-secondary-xs-dropdown"
              itemStyle="secondary"
              label="Select xs"
              size="xs"
              [items]="[
                {
                  Id: 0,
                  Name: 'SI',
                },
                {
                  Id: 1,
                  Name: 'DE',
                },
                {
                  Id: 2,
                  Name: 'NL',
                },
                {
                  Id: 3,
                  Name: 'BE',
                },
                {
                  Id: 4,
                  Name: 'HU',
                },
                {
                  Id: 5,
                  Name: 'CZ',
                },
                {
                  Id: 6,
                  Name: 'SW',
                },
                {
                  Id: 7,
                  Name: 'FR',
                },
              ]"
              [multiple]="true"
              [options]="{
                leftIcon: 'filter',
                innerLabel: inputsForm.controls.selectXS.value ? 'Regioooons:' : 'Regioooons',
                showFirstNPlusMore: 5,
              }" />
            <bn-web-ui-select
              class="mt-2"
              formControlName="selectXS"
              id="select-secondary-xs-2-dropdown"
              itemStyle="secondary"
              label="Select xs"
              size="xs"
              [items]="[
                {
                  Id: 0,
                  Name: 'SI',
                },
                {
                  Id: 1,
                  Name: 'DE',
                },
                {
                  Id: 2,
                  Name: 'NL',
                },
                {
                  Id: 3,
                  Name: 'BE',
                },
                {
                  Id: 4,
                  Name: 'HU',
                },
                {
                  Id: 5,
                  Name: 'CZ',
                },
                {
                  Id: 6,
                  Name: 'SW',
                },
                {
                  Id: 7,
                  Name: 'FR',
                },
              ]"
              [options]="{
                innerLabel: inputsForm.controls.selectXS.value ? 'Regioooons:' : 'Regioooons',
              }" />
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <bn-web-ui-card
      #gradientIcon
      heading="Gradient Icon">
      <fa-icon
        class="gradientIcon me-5"
        icon="gear"
        [size]="'6x'" />
      <fa-icon
        class="gradientIcon gradient-info me-5"
        icon="hard-drive"
        [size]="'6x'" />
      <fa-icon
        class="gradientIcon gradient-success me-5"
        icon="circle-exclamation"
        [size]="'6x'" />
      <fa-icon
        class="gradientIcon gradient-danger me-5"
        icon="circle-exclamation"
        [size]="'6x'" />
    </bn-web-ui-card>
  </div>
</bn-web-ui-content>
